var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompanyGroup = function SvgCompanyGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 12,
    fill: "#999",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9.5,
    x: 4,
    y: 2.5,
    fill: "#999",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 12,
    x: 1.5,
    y: 2,
    fill: "#6be",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9.5,
    x: 6,
    y: 4.5,
    fill: "#6be",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 12,
    x: 3,
    y: 4,
    fill: "#666",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9.5,
    x: 8,
    y: 6.5,
    fill: "#666",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 4,
    y: 5,
    fill: "#fff",
    rx: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 4,
    y: 8,
    fill: "#fff",
    rx: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 4,
    y: 11,
    fill: "#fff",
    rx: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 7,
    y: 5,
    fill: "#fff",
    rx: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 7,
    y: 8,
    fill: "#fff",
    rx: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 7,
    y: 11,
    fill: "#fff",
    rx: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 10,
    y: 8,
    fill: "#fff",
    rx: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 10,
    y: 11,
    fill: "#fff",
    rx: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 13,
    y: 8,
    fill: "#fff",
    rx: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 13,
    y: 11,
    fill: "#fff",
    rx: 0
  }))));
};
export default SvgCompanyGroup;